<template>
  <div class="tw:flex tw:flex-col tw:gap-4 tw:w-full tw:@md:w-3/4 tw:mx-auto tw:justify-center tw:h-full tw:px-4">
    <slot />
  </div>
</template>

<script setup>

</script>
